import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";

function ReadOnlyPkgSplitsContainerTypesRow({
  pkgSplitsContainerTypes,
  selectedNode,
  handleEditClick,
  handleDeleteClick,
}) {
  return (
    <Table spacing="small">
      <TableRow>
        <TableCell width={100}>
          <Input value={selectedNode} />
        </TableCell>
        <TableCell width={200}>
          <Input value={pkgSplitsContainerTypes.container_type} />
        </TableCell>
        <TableCell width={150}>
          <Input value={pkgSplitsContainerTypes.size} />
        </TableCell>
        <TableCell width={150}>
          <Input value={parseFloat(pkgSplitsContainerTypes.value).toFixed(2)} />
        </TableCell>
        <TableCell>
          <Row>
            <Button minWidth={70} onClick={(event) => handleDeleteClick(pkgSplitsContainerTypes)}>
              Delete
            </Button>
            <Button minWidth={70} onClick={(event) => handleEditClick(pkgSplitsContainerTypes)}>
              Edit
            </Button>
          </Row>
        </TableCell>
      </TableRow>
    </Table>
  );
}

export default ReadOnlyPkgSplitsContainerTypesRow;
